import { useEffect } from 'react';
import { useLocalSearchParams, router } from 'expo-router';

/**
 * The checklist used to be its own drill-in screen; it's now featured
 * directly on /structure/[id] (see PropertyChecklistSection). This route
 * stays as a redirect so old links, notification deep links, and any saved
 * bookmarks still land somewhere real. `?item=` (an item to pre-expand)
 * carries through unchanged.
 */
export default function StructureChecklistRedirect() {
  const { id, item } = useLocalSearchParams<{ id: string; item?: string }>();

  useEffect(() => {
    if (!id) return;
    router.replace(item ? `/structure/${id}?item=${encodeURIComponent(item)}` : `/structure/${id}`);
  }, [id, item]);

  return null;
}
